import React, {useEffect, useRef} from 'react';
import videojs  from '!video.js';
import Player from 'video.js/dist/types/player';
import 'video.js/dist/video-js.css';
import {useStyles} from './styles';
import {getCurrentLang, Translate} from '../../locales/locales-utils';
import VideoProcessingImgRu from '../../../src/images/video-player/video_processing_ru.png';
import VideoProcessingImgEn from '../../../src/images/video-player/video_processing_en.png';

type Props = {
  videoUrl: string;
  thumbnailUrl: string;
};

export const VideoPlayer = ({ videoUrl, thumbnailUrl }: Props) => {
  const classes = useStyles();
  const videoNode = useRef<any>();
  const player = useRef<Player>();
  const lng = getCurrentLang();
  const isAMSVideo = videoUrl?.includes('windows') || videoUrl?.includes('azure');
  const videoProcessingImgPath = lng === 'ru' ? VideoProcessingImgRu : VideoProcessingImgEn;

  useEffect(() => {
    if (!isAMSVideo && videoNode.current && videoUrl) {
      player.current = videojs(videoNode.current, {
        controls: true,
        fluid: false,
        responsive: true,
        poster: thumbnailUrl,
        sources: [
          {
            src: videoUrl,
            type: 'application/x-mpegURL'
          }
        ]
      });
    }
    return () => {
      if (player.current) {
        player.current.dispose();
      }
    };
  }, [videoUrl]);

  return (
    <>
    {(!isAMSVideo && videoUrl) &&
      <div data-vjs-player>
          <video ref={videoNode} className="video-js"/>
      </div>
    }
    {!videoUrl &&
        <div className={classes.videoProcessingStub}>
          <img src={videoProcessingImgPath} alt="Video processing image" />
        </div>
    }
    {isAMSVideo &&
      <div className={classes.videoNotSupportedStub}>
        {Translate('VideoPlayer.NotSupported')}
      </div>
    }
    </>
  );
};
